import React from 'react';

import { useStoreContext } from 'features/store';
import { isObject } from 'lodash-es';
import { useIntl } from 'react-intl';

import Dialog from 'components/dialog';

export const StoreOrderingUnavailableDialog = React.memo(() => {
  const {
    orderingUnavailableOpen,
    enableOrdering,
    onConfirmLocateRestaurants,
    onDismissStoreUnavailable,
  } = useStoreContext();
  const { formatMessage } = useIntl();
  if (!orderingUnavailableOpen) {
    return null;
  }

  return (
    <Dialog
      showDialog
      heading={
        isObject(orderingUnavailableOpen) && orderingUnavailableOpen.headingOverride
          ? orderingUnavailableOpen.headingOverride
          : formatMessage({ id: 'storeClosed' })
      }
      body={
        isObject(orderingUnavailableOpen) && orderingUnavailableOpen?.bodyOverride
          ? orderingUnavailableOpen?.bodyOverride
          : formatMessage({
              id: enableOrdering ? 'cannotPlaceOrder' : 'closeMessageToFindNearbyRestaurants',
            })
      }
      confirmButtonLabel={formatMessage({ id: 'findRestaurants' })}
      confirmDialog={onConfirmLocateRestaurants}
      onDismiss={onDismissStoreUnavailable}
      modalAppearanceEventMessage="Ordering is unavailable"
      isErrorModal
    />
  );
});
